import { put, call, delay } from 'redux-saga/effects';
import { Types } from './actions';
import { Types as TypesRequestStatus } from '../../getStudentProcedureStatus/actions';
import ProcedureRepository from '../../../../repositories/ProceduresRepository';
import ProceduresDataRepository from '../../../../../data/repositories/ProceduresDataRepository';
import config from '../../../../../core/config/config';

export default function* execute(action: any): any {
  try {
    yield put({ type: Types.ACTIVATE_CARNET_UNIVERSITY_REQUEST });
    const carnetUniversityRepository: ProcedureRepository =
      new ProceduresDataRepository();
    const carnetUniversityResponse = yield call(
      carnetUniversityRepository.activateRegisterCarnet,
      action.requestId,
      action.procedureId,
      action.deliveryMode,
      action.career
    );

    if (config.DATASOURCE_ENV === 'MOCK') yield delay(1000);
    if (!carnetUniversityResponse) {
      yield put({
        type: Types.ACTIVATE_CARNET_UNIVERSITY_FAILURE,
        error: 'No se pudo registrar'
      });
      return;
    }

    if (carnetUniversityResponse?.error) {
      yield put({
        type: Types.ACTIVATE_CARNET_UNIVERSITY_FAILURE,
        requestId: carnetUniversityResponse?.requestId,
        procedureId: carnetUniversityResponse?.procedureId,
        error:
          carnetUniversityResponse?.error ||
          'Ocurrió un error al momento de cancelar la solicitud.'
      });
      return;
    }
    yield put({
      type: TypesRequestStatus.GET_STUDENT_PROCEDURE_STATUS,
      procedureId: action.procedureId,
      requestId: action.requestId + (config.DATASOURCE_ENV === 'MOCK' ? 1 : 0)
    });
    yield put({
      type: Types.ACTIVATE_CARNET_UNIVERSITY_SUCCESS,
      requestId: carnetUniversityResponse?.requestId,
      procedureId: carnetUniversityResponse?.procedureId
    });
  } catch (error) {
    yield put({
      type: Types.ACTIVATE_CARNET_UNIVERSITY_FAILURE,
      error: 'Ocurrió un error al momento de cancelar la solicitud.'
    });
  }
}
